<div class="avi-metrics-cell">
    <gradient-loader
        class="avi-metrics-cell__loader"
        *ngIf="isLoading; else dataBlock"
    ></gradient-loader>

    <ng-template #dataBlock>
        <ng-container *ngIf="hasData; else noData">
            <ng-container
                *ngIf="series | normalizeMetricsCellData:metricsDisplayValueType:isLoading as valueObj"
            >
                <ng-container *ngIf="valueObj.value !== 'NA'; else na">
                    <span class="sel-value">
                        {{ valueObj.value | toFixed:valueDecimalPoint }}
                    </span>
                    <span
                        *ngIf="valueObj.value > -1"
                        class="avi-metrics-cell__unit-label"
                    >
                        {{ valueObj.unit }}
                    </span>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-template>

    <ng-template #noData>
        <span class="avi-metrics-cell__no-data">&#8212;</span>
    </ng-template>

    <ng-template #na>
        <span>N/A</span>
    </ng-template>
</div>
